import { render, staticRenderFns } from "./ga_map.vue?vue&type=template&id=2bd5dddb&scoped=true"
import script from "./ga_map.vue?vue&type=script&lang=js"
export * from "./ga_map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd5dddb",
  null
  
)

export default component.exports